import { useRef } from 'react';
import { useMount } from 'react-use';

export default function SelfClickingLink({ url, onClicked }: { url: string; onClicked?: () => void }) {
  const refTag = useRef<HTMLAnchorElement>(null);

  useMount(() => {
    refTag.current?.click();
    onClicked();
  });

  return (
    <a href={url} ref={refTag} className="hidden" aria-hidden>
      &nbsp;
    </a>
  );
}
